/*!

=========================================================
* Light Bootstrap Dashboard PRO React - v1.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/light-bootstrap-dashboard-pro-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, { Component } from "react";
import {
  Grid,
  Row,
  Col,
  Table,
  OverlayTrigger,
  FormControl,
  Pagination,
  Tooltip,
} from "react-bootstrap";
import {
  GetSubscription,
  DeleteSubscription,
  DeleteSubscriptionPackage,
  searchSubscription,
  GetSubscriptionPackageList,
  searchSubscriptionPackage,
} from "../../../Listfunction";
// react component that creates a switch button that changes from on to off mode
import { Link, withRouter } from "react-router-dom";
import ReactTable from "react-table";

import Switch from "react-bootstrap-switch";

import LoadingSpinner from "views/Components/loadingSpinner";

import Card from "components/Card/Card.jsx";
import SweetAlert from "react-bootstrap-sweetalert";

import Button from "components/CustomButton/CustomButton.jsx";

class viewSubscriptionpackage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      subscription_detail: [],
      category: [],
      paginationData: [],
      nextpage: "",
      prevpage: "",
      currentPage: 1,
      nextdisabled: "1",
      prevdisabled: "1",
      tabledata: "",
      tier_name: "",
      subscription_fees: "",
      description: "",
      delivery_distance_from: "",
      delivery_distance_to: "",
      title: "",
      description: "",
      size: "",
      brand: "",
      page: "",
      loading: false,
      alert: null,
      useraccess: "",
      noRecordFound: false,
    };
    this.selectedsubscription = this.selectedsubscription.bind(this);
    this.deleteSubscriptionPackage = this.deleteSubscriptionPackage.bind(this);
    this.searchdata = this.searchdata.bind(this);
    this.searchData = this.searchData.bind(this);
    this.resetSearch = this.resetSearch.bind(this);
    this.paginationinfo = this.paginationinfo.bind(this);
    this.onChange = this.onChange.bind(this);
    this.warningWithConfirmAndCancelMessage =
      this.warningWithConfirmAndCancelMessage.bind(this);
  }
  selectedsubscription(cus) {
    localStorage.setItem("subscriptionpackageID", JSON.stringify(cus));

    // this.props.history.push('/admin/editsubscriptionpackage');
  }
  componentDidMount() {
    var token = JSON.parse(localStorage.getItem("user"));

    const obj = token.token;
    GetSubscriptionPackageList(obj).then((response) => {
      console.log(response.data.data.data);
      this.setState({
        subscription_detail: response.data.data.data,
        useraccess: token.role,
      });
    });
    this.searchData();
  }
  onChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };
  paginationinfo(url) {
    this.setState({ page: url });
    this.searchData();
  }
  searchdata(e) {
    this.setState({ page: "" });
    this.searchData();
  }
  resetSearch(e) {
    this.setState({ tier_name: "", subscription_fees: "", description: "" });
    this.searchData();
  }
  searchData(e) {
    var token = JSON.parse(localStorage.getItem("user"));
    // console.log(token.token);
    const obj = token.token;
    this.setState({ noRecordFound: false });

    // console.log(this.state.itemcode,this.state.description,this.state.price,this.state.medicationcategory,this.state.commision,this.state.unitprice,this.state.page)
    this.setState({ loading: true }, () => {
      searchSubscriptionPackage(
        this.state.title,
        this.state.description,
        this.state.size,
        this.state.brand,
        this.state.page,
        obj
      ).then((response1) => {
        var data = response1.data;

        // console.log(data.next_page_url);
        // console.log(data,data.last_page);
        if (data.data.length == 0) {
          this.setState({ noRecordFound: true });
        }
        var $no_pages = [];
        let serach_string = "";
        for (var i = 1; i <= data.last_page; i++) {
          if (serach_string == "") {
            $no_pages.push(i);
          } else {
            $no_pages.push(i);
          }
        }

        if (data.current_page == data.last_page) {
          this.setState({ prevdisabled: null });
          this.setState({ nextdisabled: "1" });
        } else if (data.current_page == 1) {
          this.setState({ nextdisabled: null });
          this.setState({ prevdisabled: "1" });
        } else {
          this.setState({ nextdisabled: null });
          this.setState({ prevdisabled: null });
        }
        if (data.last_page == 1) {
          this.setState({ nextdisabled: 1 });
          this.setState({ prevdisabled: 1 });
        }
        if (data.data.length == 0) {
          $no_pages = [];
          this.setState({ nextdisabled: 1 });
          this.setState({ prevdisabled: 1 });
        }
        this.setState({ currentPage: data.current_page });
        if (data.next_page_url != null) {
          if (serach_string == "") {
            this.setState({
              nextpage: data.next_page_url.substring(
                data.next_page_url.indexOf("=") + 1
              ),
            });
          } else {
            this.setState({
              nextpage: data.next_page_url.substring(
                data.next_page_url.indexOf("=") + 1
              ),
            });
          }
        } else {
          this.setState({ nextpage: "#" });
        }
        if (data.prev_page_url != null) {
          if (serach_string == "") {
            this.setState({
              prevpage: data.prev_page_url.substring(
                data.prev_page_url.indexOf("?page=") + 1
              ),
            });
          } else {
            this.setState({
              prevpage: data.prev_page_url.substring(
                data.prev_page_url.indexOf("?page=") + 1
              ),
            });
          }
        } else {
          this.setState({ prevpage: "#" });
        }

        this.setState({ paginationData: $no_pages });

        this.setState({
          loading: false,
          subscription_detail: data.data,
        });
      });
    });
  }

  warningWithConfirmAndCancelMessage(id) {
    // alert('hi');
    this.setState({
      alert: (
        <SweetAlert
          warning
          style={{ display: "block", marginTop: "-100px" }}
          title="Are you sure?"
          onConfirm={() => this.deleteSubscriptionPackage(id)}
          onCancel={() => this.hideAlert()}
          confirmBtnBsStyle="info"
          cancelBtnBsStyle="danger"
          confirmBtnText="Yes, delete it!"
          cancelBtnText="Cancel"
          showCancel
        >
          You will not be able to recover this Subscription Package Detail !
        </SweetAlert>
      ),
    });
  }
  hideAlert() {
    this.setState({
      alert: null,
    });
  }
  deleteSubscriptionPackage(id) {
    var token = JSON.parse(localStorage.getItem("user"));
    // console.log(token.token);
    const obj = token.token;
    // alert(id);
    // console.log(id);
    DeleteSubscriptionPackage(id, obj).then(() => {
      this.setState({
        alert: null,
      });
      this.searchData();
    });
  }
  addsubscriptionpackage() {
    this.props.history.push("/admin/addsubscriptionpackage");
  }
  render() {
    const view = <Tooltip id="view">View Profile</Tooltip>;
    const edit = <Tooltip id="edit">Edit</Tooltip>;
    const remove = <Tooltip id="remove">Remove</Tooltip>;
    const subscription_detail = this.state.subscription_detail;
    const category = this.state.category;
    // console.log(medication_detail);
    var c = 1;

    return (
      <div className="main-content">
        <Grid fluid>
          {this.state.alert}
          <Row>
            <Col md={12}>
              <Card
                tableFullWidth
                content={
                  <Row>
                    <Col md={12} sm={12} lg={12} xs={12}>
                      <Col
                        md={12}
                        sm={12}
                        lg={12}
                        xs={12}
                        className="text-right"
                      >
                        <Button
                          className="btn-fill fl_mb_1 fl_mb_web_1"
                          class="btn-color "
                          style={{ width: "180px" }} //bsStyle="info"
                          fill
                          onClick={this.addsubscriptionpackage.bind(this)}
                        >
                          Product Item<i className="fa fa-plus"></i>
                        </Button>
                      </Col>
                    </Col>
                    <Col md={12} sm={12} lg={12} xs={12}>
                      {/* <Col  md={3} sm={4} lg={3}  xs={12} className="fl_mb_1" >
                  <FormControl  name="tier_name" value={this.state.tier_name ||''} placeholder="Tier Name" onChange={this.onChange} type="text" />
                  </Col>
                  <Col md={3} sm={4} lg={3}  xs={12} className="fl_mb_1">
                  <FormControl name="subscription_fees" value={this.state.subscription_fees ||''} placeholder="Subscription Fees" onChange={this.onChange} type="text" />
                  </Col>
                  <Col md={3} sm={4} lg={3}  xs={12}>
                  <FormControl className="fl_mb_1" name="description" value={this.state.description ||''} placeholder="Description" onChange={this.onChange} type="text" />
                  </Col>
                  <Col md={3} sm={4} lg={3}  xs={12} className="fl_mb_1">
                  <Button class="btn-color" //bsStyle="info"
                   fill onClick={this.searchdata.bind(this)}>Filter</Button>&nbsp;&nbsp;
                    <Button class="btn-color" //bsStyle="info"
                     fill onClick={this.resetSearch.bind(this)}>Reset</Button>
                  </Col> */}
                    </Col>
                    {/* <Col md={2} style={{width:'160px'}}>
                  <FormControl name="delivery_distance_from" value={this.state.delivery_distance_from ||''} placeholder="Delivery Distance From" onChange={this.onChange} type="text" />
                  </Col> 
                 <Col md={2} style={{width:'160px'}}>
                  <FormControl name="delivery_distance_to" value={this.state.delivery_distance_to ||''} placeholder="Delivery Distance To" onChange={this.onChange} type="text" />
                  </Col> */}
                    <Col md={12} sm={12} lg={12} xs={12}>
                      <Table responsive>
                        <thead>
                          <tr>
                            <th>#id</th>
                            <th>Title</th>
                            <th>Brand</th>
                            <th>Description</th>
                            <th>size</th>
                            <th className="text-right">Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.state.loading ? (
                            <tr>
                              <td colspan="10">
                                <LoadingSpinner />
                              </td>
                            </tr>
                          ) : this.state.noRecordFound ? (
                            <tr>
                              <td colspan="10">
                                <center>No record found</center>
                              </td>
                            </tr>
                          ) : (
                            <React.Fragment>
                              {subscription_detail.map((cus) => (
                                <tr>
                                  <td>{cus.id}</td>
                                  <td key={cus.id}>{cus.title}</td>
                                  <td>{cus.brand}</td>
                                  <td>{cus.description}</td>
                                  <td>{cus.size}</td>

                                  <td className="td-actions text-right">
                                    <OverlayTrigger
                                      placement="top"
                                      overlay={edit}
                                    >
                                      <Button
                                        simple
                                        bsStyle="success"
                                        onClick={this.selectedsubscription.bind(
                                          this,
                                          cus.id
                                        )}
                                        bsSize="xs"
                                      >
                                        <Link to="/admin/editsubscriptionpackage">
                                          <i className="fa fa-edit" />
                                        </Link>
                                      </Button>
                                    </OverlayTrigger>
                                    {this.state.useraccess == 1 && (
                                      <OverlayTrigger
                                        placement="top"
                                        overlay={remove}
                                      >
                                        <Button
                                          simple
                                          bsStyle="danger"
                                          onClick={this.warningWithConfirmAndCancelMessage.bind(
                                            this,
                                            cus.id
                                          )}
                                          bsSize="xs"
                                        >
                                          <i className="fa fa-times" />
                                        </Button>
                                      </OverlayTrigger>
                                    )}
                                  </td>
                                </tr>
                              ))}
                            </React.Fragment>
                          )}
                        </tbody>
                      </Table>
                      {this.state.loading ? (
                        ""
                      ) : this.state.noRecordFound ? (
                        ""
                      ) : (
                        <div style={{ textAlign: "center" }}>
                          <Pagination>
                            <Pagination.First
                              onClick={this.paginationinfo.bind(
                                this,
                                this.state.prevpage
                              )}
                              disabled={this.state.prevdisabled}
                            />
                            {this.state.paginationData.map((url) => (
                              <Pagination.Item
                                active={
                                  this.state.currentPage == c ? "1" : null
                                }
                                onClick={this.paginationinfo.bind(this, url)}
                              >
                                {c++}
                              </Pagination.Item>
                            ))}
                            <Pagination.Last
                              onClick={this.paginationinfo.bind(
                                this,
                                this.state.nextpage
                              )}
                              disabled={this.state.nextdisabled}
                            />
                          </Pagination>
                        </div>
                      )}
                    </Col>
                  </Row>
                }
              />
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

export default viewSubscriptionpackage;
